<template>
  <div class="input-group">
    <label>{{ label }}</label>
    <select :value="selectedValue" @change="handleChange">
      <option disabled value="">Seleccione una opción</option>
      <option v-for="(code, name) in roles" :key="code" :value="name">{{ name }}</option>
    </select>

    <input
      v-if="selectedValue === 'Otro (especificar)'"
      type="text"
      placeholder="Especifique su rol"
      v-model="otroInput"
      @input="emitirOtro"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    label: String
  },
  data() {
    return {
      roles: {
        "Cliente final": "a",
        "Agencia de eventos": "b",
        "Otro (especificar)": "c"
      },
      selectedValue: this.value,
      otroInput: ''
    }
  },
  methods: {
    handleChange(event) {
      this.selectedValue = event.target.value
      if (this.selectedValue === 'Otro (especificar)') {
        this.emitirOtro()
      } else {
        this.$emit('input', this.roles[this.selectedValue])
      }
    },
    emitirOtro() {
      this.$emit('input', this.otroInput || 'otro')
    }
  },
  watch: {
    otroInput() {
      this.emitirOtro()
    }
  }
}
</script>
